import { render, staticRenderFns } from "./OrganizationProfile.vue?vue&type=template&id=26ceeca8&"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26ceeca8')) {
      api.createRecord('26ceeca8', component.options)
    } else {
      api.reload('26ceeca8', component.options)
    }
    module.hot.accept("./OrganizationProfile.vue?vue&type=template&id=26ceeca8&", function () {
      api.rerender('26ceeca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/organizations/OrganizationProfile.vue"
export default component.exports